/// <reference types="vite/client" />
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";

import { App } from "./App";
import { router } from "./routes";
import "./index.css";

/**
 * Accessibility checking in development only.
 *
 * @axe-core/react walks the rendered tree and logs violations to the console.
 * It is a dev dependency and a dynamic import, so it is never in the production
 * bundle. The await is deliberate: axe has to be installed before the first
 * render, or it misses the initial tree.
 */
async function enableAxe(): Promise<void> {
  if (!import.meta.env.DEV) return;
  const [{ default: axe }, React, ReactDOM] = await Promise.all([
    import("@axe-core/react"),
    import("react"),
    import("react-dom"),
  ]);
  await axe(React, ReactDOM, 1000);
}

async function start(): Promise<void> {
  const container = document.getElementById("root");
  if (container === null) {
    throw new Error("#root is missing from index.html");
  }
  await enableAxe();
  createRoot(container).render(
    <StrictMode>
      <App>
        <RouterProvider router={router} />
      </App>
    </StrictMode>,
  );
}

void start();
